/**
 * Vehicle drive train type values
 */
export enum VehicleDriveTrainTypeEnum {
	FRONT_WHEEL_DRIVE = 'front_wheel_drive',
	FOUR_BY_FOUR = 'four_by_four',
	REAR_WHEEL_DRIVE = 'rear_wheel_drive',
	ALL_WHEEL_DRIVE = 'all_wheel_drive',
	NON_STANDARDIZED = 'non_standardized',
}
